import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=0bbd1b6f&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=0bbd1b6f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bbd1b6f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0bbd1b6f')) {
      api.createRecord('0bbd1b6f', component.options)
    } else {
      api.reload('0bbd1b6f', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=0bbd1b6f&scoped=true&", function () {
      api.rerender('0bbd1b6f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8WsyQkOL06k6v/JS/comp/GuestBox.vue"
export default component.exports